import api from '../../api/client';
import React, { useState, useEffect } from "react";
import {
  Card,
  Row,
  Col,
  Button,
  Alert,
  Statistic,
  Space,
  Typography,
  Spin,
} from "antd";
import {
  ClockCircleOutlined,
  LoginOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import axios from "axios";
import { useSelector } from "react-redux";
import config from "../../config";
import MonthlySummary from "./MonthlySummary"; // keep as is or convert later

const { Title, Text } = Typography;

const AttendanceClockPage = () => {
  const [attendance, setAttendance] = useState(null);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const environment =
    window.location.hostname === "localhost" ? "development" : "production";
  const apiUrl = config[environment].apiUrl;
  const account = useSelector((state) => state.account.user);
  const userId = account.id;

  useEffect(() => {
    fetchTodayAttendance();
  }, []);

  const fetchTodayAttendance = async () => {
    const today = dayjs().format("YYYY-MM-DD");
    try {
      const { data } = await api.get(
        `/hr/attendance/daily?date=${today}`,
      );
      const userRecord = data.find((record) => record.user_id === userId);
      setAttendance(userRecord || null);
    } catch (error) {
      console.error("Failed to fetch attendance:", error);
    }
  };

  const handleClockAction = async (action) => {
    setLoading(true);
    try {
      const { data } = await api.post(`/attendance/clock`, {
        userId,
        action,
      });
      setMessage(data.message || data.error || "Unknown response");
      fetchTodayAttendance();
    } catch (error) {
      setMessage("An error occurred while clocking.");
    } finally {
      setLoading(false);
    }
  };

  const now = dayjs();

  return (
    <div style={{ padding: 24, maxWidth: 600, margin: "0 auto" }}>
      <Card title="Attendance Clock" bordered={false}>
        <div style={{ textAlign: "center", marginBottom: 24 }}>
          <Statistic
            value={now.format("HH:mm")}
            prefix={<ClockCircleOutlined />}
            valueStyle={{ fontSize: 48 }}
          />
          <Text type="secondary" style={{ display: "block", marginTop: 8 }}>
            {now.format("dddd, MMMM D, YYYY")}
          </Text>
        </div>

        {message && (
          <Alert
            message={message}
            type={
              message.toLowerCase().includes("success") ? "success" : "error"
            }
            showIcon
            closable
            onClose={() => setMessage("")}
            style={{ marginBottom: 16 }}
          />
        )}

        <Row gutter={16} style={{ marginBottom: 24 }}>
          <Col span={12}>
            <Card size="small">
              <Statistic
                title="Clock In"
                value={attendance?.clock_in || "--:--"}
                valueStyle={{ color: "#1677ff" }}
              />
            </Card>
          </Col>
          <Col span={12}>
            <Card size="small">
              <Statistic
                title="Clock Out"
                value={attendance?.clock_out || "--:--"}
                valueStyle={{ color: "#52c41a" }}
              />
            </Card>
          </Col>
        </Row>

        <Space direction="vertical" style={{ width: "100%" }}>
          {!attendance?.clock_in ? (
            <Button
              type="primary"
              size="large"
              icon={<LoginOutlined />}
              onClick={() => handleClockAction("in")}
              loading={loading}
              block
            >
              Clock In
            </Button>
          ) : !attendance?.clock_out ? (
            <Button
              type="primary"
              size="large"
              icon={<LogoutOutlined />}
              onClick={() => handleClockAction("out")}
              loading={loading}
              block
              style={{ backgroundColor: "#52c41a", borderColor: "#52c41a" }}
            >
              Clock Out
            </Button>
          ) : (
            <Alert
              message="Already clocked out for today"
              type="info"
              showIcon
            />
          )}
        </Space>

        {attendance?.hours && attendance.hours !== "--" && (
          <Alert
            message="Hours worked today"
            description={<strong>{attendance.hours} hours</strong>}
            type="warning"
            showIcon
            style={{ marginTop: 16 }}
          />
        )}
      </Card>

      <Card
        title="This Month's Summary"
        style={{ marginTop: 24 }}
        bordered={false}
      >
        <MonthlySummary userId={userId} />
      </Card>
    </div>
  );
};

export default AttendanceClockPage;
